export default {
      id: "info-usage",
      viewBox: "0 0 330 330",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#info-usage",
      toString: function () {
        return this.url;
      }
    }